module.exports = __webpack_public_path__ + "img/banner_01.d4065baa.jpg";